import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { WithTranslation, withTranslation, Trans } from 'react-i18next';
import { DialogContentText } from '@material-ui/core';

export type Content = {
    message: string,
    messageBoldPrimary?: string,
    redValue? :boolean,
    icon?: any
}

interface ModalProps {
    open: boolean,
    okCallback: () => void,
    cancelCallback: () => void,
    dialogContent: Content[],
    windowWidth: number,
    zmieniany: boolean,
}



class Notifier extends React.Component<ModalProps & WithStyles<typeof styles> & WithTranslation> {

    Icon = (Icon: any, color: string = '#458B00') => {
        return <Icon style={{ fontSize: "25px", marginRight: "10px", float: "left", color: color }} /> 
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog
                maxWidth="xs"
                open={this.props.open}
                onClose={this.props.cancelCallback}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem", textTransform: "lowercase" }}>
                        <b><Trans>Confirmation</Trans></b>
                    </Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>


                    {this.props.dialogContent.map((text, index) => (
                        <DialogContentText key={index} color="primary" style={{ paddingLeft: text.message.includes("*") ? "12px" : "0", minHeight: "24px", fontSize: this.props.windowWidth < 600 ? "0.9rem" : "1rem" }}>
                            {text.icon ? this.Icon(text.icon, "#458B00") : null}
                            {text.message}
                            {text.messageBoldPrimary ?
                                <b className={text.redValue ? classes.error : classes.primary}>{text.messageBoldPrimary}</b> : null}
                        </DialogContentText>
                    ))}



                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="primary" size="small" style={{ textTransform: "none" }}
                        onClick={this.props.cancelCallback}
                    >
                        <b><Trans>back data</Trans></b>
                    </Button>
                    <Button variant="contained" color="primary" size="small"
                        onClick={this.props.okCallback}
                    >
                        <b><Trans>{this.props.zmieniany ?  "Save" :"Reserve" }</Trans></b>
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = (theme: Theme) => ({
    textAlignLeft: {
        textAlign: 'left' as 'left',
    },
    fontWeightNormal: {
        fontWeight: 'normal' as 'normal',
    },
    uppercase: {
        textTransform: "uppercase" as "uppercase"
    },
    input: {
        backgroundColor: '#ffffff',
        color: "rgb(0, 0, 0)"
    },
    primary: {
        color: theme.palette.primary.main
    },
    error: {
        color: theme.palette.error.main
    },
});

export default withTranslation()(withStyles(styles)(Notifier));